import { CommonStyles } from '~common/react/CommonStyles';

import { cssClass } from '../../style';

const cssPrefix = 'LicenseTabe';

export namespace LicenseTabStyle {
  export const licenseInfo = cssClass(cssPrefix, 'info', {
    marginRight:  '75px',
  });

  export const headerLine = cssClass(cssPrefix, 'header', {
    height: CommonStyles.Sizes.DataGridHeaderHeight,
    borderTop: `1px solid ${CommonStyles.Colors.DividerLineColor}`,
    borderBottom: `1px solid ${CommonStyles.Colors.DividerLineColor}`,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    backgroundColor: CommonStyles.Colors.White,
    verticalAlign: 'top',
  });

  export const headerNumberic = cssClass(cssPrefix, 'number', {
    textAlign : 'right',
  });

  export const headerIcon = cssClass(cssPrefix, 'icon', {
    textAlign: 'center',
  });

  export const settingContainer = cssClass(cssPrefix, 'container', {
    marginLeft: '85px',
    width: '508px',
  });

}